var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoubleCheck = function SvgDoubleCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.5334 4.19999c-.26-.26-.68-.26-.94 0l-3.75998 3.76.94.94 3.75998-3.76667c.2534-.25333.2534-.68 0-.93333zm2.8267-.00667-6.58668 6.58668-2.32-2.31335c-.26-.26-.68-.26-.94 0s-.26.68 0 .94l2.78667 2.78665c.26.26.68.26.94 0l7.06001-7.05331c.26-.26.26-.68 0-.94h-.0067c-.2533-.26667-.6733-.26667-.9333-.00667zm-13.613342 5.22 2.786662 2.78668c.26.26.68.26.94 0l.46667-.4667-3.25333-3.26665c-.26-.26-.68-.26-.940002 0-.26.26-.26.68667 0 .94667z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/double_check.5070c9a2.svg";
export { ForwardRef as ReactComponent };